import React from "react";
import { ClipboardCheck, FileDown } from "lucide-react";
import { fmtDT } from "../lib/date";
import { OwnerVrEmbed } from "./OwnerVrEmbed";
import { makeT, pickPair } from "../lib/ownerI18n";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const LEVEL_CLS = { low: "bg-emerald-100 text-emerald-700 border-emerald-200", mid: "bg-amber-100 text-amber-700 border-amber-200", high: "bg-red-100 text-red-700 border-red-200", review: "bg-violet-100 text-violet-700 border-violet-200" };

/* 业主门户：五页清单全部提交后显示踏勘报告（PDF）与 360 全景（跳转免登录分享页） */
export const OwnerSiteSurveyCard = ({ token, s, lang = "zh" }) => {
  const zh = lang === "zh";
  const T = makeT(lang);
  if (!s) return null;
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4" data-testid="owner-site-survey">
      <p className="text-sm font-bold text-slate-800 mb-1 flex items-center gap-1.5"><ClipboardCheck className="h-4 w-4 text-amber-600" />{T("现场踏勘报告", "Site Survey Report")}</p>
      <p className="text-[11px] text-slate-500 mb-2">{T("项目经理已完成五项现场踏勘清单", "Your PM completed all five site checklists")} · {fmtDT(s.completedAt)}{s.reportVersion > 1 ? ` · v${s.reportVersion}` : ""}</p>
      <div className="flex flex-wrap gap-1.5 mb-3" data-testid="owner-site-survey-pages">
        {s.pages.map((p) => (
          <span key={p.key} className="inline-flex items-center gap-1 text-[11px] px-2 py-1 rounded-full border bg-slate-50 border-slate-200 text-slate-700" data-testid={`owner-site-survey-page-${p.key}`}>
            {pickPair(p.name.zh, p.name.en, lang)}
            {p.level && <span className={`text-[10px] px-1.5 rounded border ${LEVEL_CLS[p.conclusion] || ""}`}>{pickPair(p.level.zh, p.level.en, lang)}</span>}
            {p.key === "photo_video" && p.demo && <span className="text-[10px] px-1.5 rounded border bg-white border-slate-200">{p.demo === "needed" ? T("需拆除", "Demo") : T("无需拆除", "No demo")}</span>}
          </span>
        ))}
      </div>
      <div className="flex flex-wrap gap-2">
        <a href={`${BACKEND}/api/public/owner-hub/${token}/survey-report.pdf?lang=${lang}`} target="_blank" rel="noreferrer" data-testid="owner-site-survey-report"
          className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-2 rounded-xl bg-slate-900 text-white hover:bg-slate-800"><FileDown className="h-3.5 w-3.5" />{T("查看踏勘报告 PDF", "View report PDF")}</a>
      </div>
      {s.vrShareUrl && s.vrCount > 0 && <OwnerVrEmbed shareUrl={s.vrShareUrl} zh={zh} />}
    </div>
  );
};
